module.exports = "/_next/static/images/icon-user-center-2b91847d.png";